export type Brand =
  | "alfa-romeo"
  | "audi"
  | "bmw"
  | "citroen"
  | "dodge"
  | "fiat"
  | "ford"
  | "honda"
  | "honda-moto"
  | "jeep"
  | "kia"
  | "lancia"
  | "land-rover"
  | "mazda"
  | "mercedes"
  | "mini"
  | "mitsubishi"
  | "nissan"
  | "opel"
  | "peugeot"
  | "porsche"
  | "renault"
  | "sea-doo"
  | "seat"
  | "skoda"
  | "subaru"
  | "toyota"
  | "volkswagen"
  | "volvo"
  | "yamaha";

export type ModelId =
  // Mercedes-Benz — R series (roadsters)
  | "r107"
  | "r129"
  | "r170"
  | "r171"
  | "r172"
  | "r197"
  | "r199"
  | "r230"
  | "r231"
  | "r232"
  // Mercedes-Benz — W series
  | "w108"
  | "w109"
  | "w111"
  | "w113"
  | "w114"
  | "w115"
  | "w116"
  | "w123"
  | "w124"
  | "w126"
  | "w140"
  | "w163"
  | "w164"
  | "w166"
  | "w167"
  | "w168"
  | "w169"
  | "w176"
  | "w177"
  | "w201"
  | "w202"
  | "w203"
  | "w204"
  | "w205"
  | "w206"
  | "w207"
  | "w208"
  | "w209"
  | "w210"
  | "w211"
  | "w212"
  | "w213"
  | "w214"
  | "w215"
  | "w216"
  | "w217"
  | "w218"
  | "w219"
  | "w220"
  | "w221"
  | "w222"
  | "w223"
  | "w245"
  | "w246"
  | "w247"
  | "w251"
  | "w414"
  | "w447"
  | "w463"
  | "w639"
  | "w906"
  | "w907"
  | "x164"
  | "x204"

  // BMW — E series
  | "e12" | "e21" | "e23" | "e24" | "e28" | "e30" | "e31" | "e32" | "e34"
  | "e36" | "e38" | "e39" | "e46" | "e52" | "e53" | "e60" | "e61" | "e63"
  | "e64" | "e65" | "e66" | "e70" | "e71" | "e72" | "e81" | "e82" | "e83"
  | "e84" | "e85" | "e86" | "e87" | "e88" | "e89" | "e90" | "e91" | "e92"
  | "e93"
  // BMW — F series
  | "f01" | "f02" | "f06" | "f07" | "f10" | "f11" | "f12" | "f13" | "f15"
  | "f16" | "f20" | "f21" | "f22" | "f23" | "f25" | "f26" | "f30" | "f31"
  | "f32" | "f33" | "f34" | "f36" | "f39" | "f40" | "f44" | "f45" | "f46"
  | "f48" | "f52" | "f54" | "f55" | "f56" | "f57" | "f80" | "f82" | "f83"
  | "f85" | "f86" | "f87" | "f90"
  // BMW — Z series
  | "z1" | "z3"
  // Volkswagen
  | "vw-golf-mk1" | "vw-golf-mk2" | "vw-golf-mk3" | "vw-golf-mk4"
  | "vw-golf-mk5" | "vw-golf-mk6" | "vw-golf-mk7" | "vw-golf-mk8"
  | "vw-jetta-mk4" | "vw-jetta-mk5" | "vw-jetta-mk6" | "vw-bora"
  | "vw-passat-b3" | "vw-passat-b4" | "vw-passat-b5" | "vw-passat-b6"
  | "vw-passat-b7" | "vw-passat-b8" | "vw-arteon" | "vw-cc"
  | "vw-polo-mk3" | "vw-polo-mk4" | "vw-polo-mk5" | "vw-polo-mk6"
  | "vw-up" | "vw-fox" | "vw-lupo" | "vw-corrado" | "vw-scirocco-mk3"
  | "vw-beetle-a4" | "vw-beetle-a5" | "vw-eos" | "vw-phaeton"
  | "vw-touran-1t" | "vw-touran-5t" | "vw-sharan-7m" | "vw-sharan-7n"
  | "vw-caddy-2k" | "vw-caddy-sb" | "vw-t4" | "vw-t5" | "vw-t6"
  | "vw-tiguan-5n" | "vw-tiguan-ad" | "vw-t-roc" | "vw-t-cross"
  | "vw-touareg-7l" | "vw-touareg-7p" | "vw-touareg-cr" | "vw-amarok"
  | "vw-id3" | "vw-id4"
  // Audi / Mini / Jeep / Porsche / Opel / Ford / Seat / Škoda / Volvo / Toyota
  // presets use slug ids declared in MODELS below. The string fallback keeps
  // them assignable while preserving autocompletion for the literals above.
  | (string & {});

export type CategoryId =
  | "brakes"
  | "suspension"
  | "engine"
  | "cooling"
  | "electrical"
  | "body"
  | "interior"
  | "lighting"
  | "exhaust"
  | "transmission";

export interface ModelInfo {
  id: ModelId;
  brand: Brand;
  label: string;
  years: string;
}

export interface CategoryInfo {
  id: CategoryId;
  label: string;
}

export interface Product {
  id: string;
  sku: string;
  oem: string[];
  name: string;
  brand: Brand | string;
  models: (ModelId | string)[];
  category: CategoryId | string;
  price: number;
  currency: "EUR";
  inStock: boolean;
  rating: number;
  reviewCount: number;
  badges: string[];
  addedAt: string;
  /** Optional pre-computed image URL (used for DB-sourced products). */
  image?: string | null;
  /** Optional URL slug for linking to the product page. */
  slug?: string;
}

export const BRANDS: { id: Brand; label: string }[] = [
  { id: "alfa-romeo", label: "Alfa Romeo" },
  { id: "audi", label: "Audi" },
  { id: "bmw", label: "BMW" },
  { id: "citroen", label: "Citroën" },
  { id: "dodge", label: "Dodge" },
  { id: "fiat", label: "Fiat" },
  { id: "ford", label: "Ford" },
  { id: "honda", label: "Honda" },
  { id: "honda-moto", label: "Honda (motorcycles)" },
  { id: "jeep", label: "Jeep" },
  { id: "kia", label: "Kia" },
  { id: "lancia", label: "Lancia" },
  { id: "land-rover", label: "Land Rover" },
  { id: "mazda", label: "Mazda" },
  { id: "mercedes", label: "Mercedes-Benz" },
  { id: "mini", label: "Mini" },
  { id: "mitsubishi", label: "Mitsubishi" },
  { id: "nissan", label: "Nissan" },
  { id: "opel", label: "Opel" },
  { id: "peugeot", label: "Peugeot" },
  { id: "porsche", label: "Porsche" },
  { id: "renault", label: "Renault" },
  { id: "sea-doo", label: "Sea-Doo" },
  { id: "seat", label: "Seat" },
  { id: "skoda", label: "Škoda" },
  { id: "subaru", label: "Subaru" },
  { id: "toyota", label: "Toyota" },
  { id: "volkswagen", label: "Volkswagen" },
  { id: "volvo", label: "Volvo" },
  { id: "yamaha", label: "Yamaha (motorcycles)" },
];

export const MODELS: ModelInfo[] = [
  // Sea-Doo model families. Exact year/trim fitment belongs to each product.
  { id: "sea-doo-rxt-x", brand: "sea-doo", label: "RXT-X (RXTX)", years: "" },
  { id: "sea-doo-gtx", brand: "sea-doo", label: "GTX", years: "" },
  { id: "sea-doo-fishpro", brand: "sea-doo", label: "FishPro (FISH)", years: "" },
  { id: "sea-doo-wake-pro", brand: "sea-doo", label: "WAKE PRO", years: "" },
  { id: "sea-doo-rxp-x", brand: "sea-doo", label: "RXP-X (RXPX)", years: "" },
  { id: "sea-doo-gti", brand: "sea-doo", label: "GTI", years: "" },
  { id: "sea-doo-gtr", brand: "sea-doo", label: "GTR", years: "" },
  // Dodge
  { id: "dodge-durango-wd", brand: "dodge", label: "Durango (WD)", years: "2011 – 2021" },
  { id: "dodge-durango-hb", brand: "dodge", label: "Durango (HB)", years: "2004 – 2009" },
  { id: "dodge-durango-dn", brand: "dodge", label: "Durango (DN)", years: "1998 – 2003" },
  { id: "dodge-durango-wd-2021", brand: "dodge", label: "Durango (WD facelift)", years: "2021 – present" },
  { id: "dodge-charger-lx", brand: "dodge", label: "Charger (LX)", years: "2006 – 2010" },
  { id: "dodge-charger-ld", brand: "dodge", label: "Charger (LD)", years: "2011 – 2023" },
  { id: "dodge-charger-lb", brand: "dodge", label: "Charger Daytona (LB)", years: "2024 – present" },
  { id: "dodge-challenger-lc", brand: "dodge", label: "Challenger (LC)", years: "2008 – 2023" },
  { id: "dodge-challenger-1970", brand: "dodge", label: "Challenger", years: "1970 – 1974" },
  { id: "dodge-journey-jc", brand: "dodge", label: "Journey (JC)", years: "2008 – 2020" },
  { id: "dodge-caliber-pm", brand: "dodge", label: "Caliber (PM)", years: "2006 – 2012" },
  { id: "dodge-avenger-js", brand: "dodge", label: "Avenger (JS)", years: "2007 – 2014" },
  { id: "dodge-dart-pf", brand: "dodge", label: "Dart (PF)", years: "2012 – 2016" },
  { id: "dodge-magnum-lx", brand: "dodge", label: "Magnum (LX)", years: "2004 – 2008" },
  { id: "dodge-nitro-ka", brand: "dodge", label: "Nitro (KA)", years: "2006 – 2012" },
  { id: "dodge-grand-caravan-rt", brand: "dodge", label: "Grand Caravan (RT)", years: "2008 – 2020" },
  { id: "dodge-grand-caravan-rs", brand: "dodge", label: "Grand Caravan (RS)", years: "2001 – 2007" },
  { id: "dodge-caravan-ns", brand: "dodge", label: "Caravan (NS)", years: "1996 – 2000" },
  { id: "dodge-ram-1500-dr", brand: "dodge", label: "Ram 1500 (DR)", years: "2002 – 2008" },
  { id: "dodge-ram-1500-ds", brand: "dodge", label: "Ram 1500 (DS)", years: "2009 – 2018" },
  { id: "dodge-ram-2500-dh", brand: "dodge", label: "Ram 2500/3500 (DH)", years: "2003 – 2009" },
  { id: "dodge-ram-br", brand: "dodge", label: "Ram (BR/BE)", years: "1994 – 2002" },
  { id: "dodge-dakota-an", brand: "dodge", label: "Dakota (AN)", years: "1997 – 2004" },
  { id: "dodge-dakota-nd", brand: "dodge", label: "Dakota (ND)", years: "2005 – 2011" },
  { id: "dodge-viper-sr", brand: "dodge", label: "Viper (SR)", years: "1992 – 2002" },
  { id: "dodge-viper-zb", brand: "dodge", label: "Viper (ZB)", years: "2003 – 2010" },
  { id: "dodge-viper-vx", brand: "dodge", label: "Viper (VX)", years: "2013 – 2017" },
  { id: "dodge-neon-pl", brand: "dodge", label: "Neon (PL)", years: "1994 – 1999" },
  { id: "dodge-neon-pt", brand: "dodge", label: "Neon / SRT-4 (PL2)", years: "2000 – 2005" },
  { id: "dodge-stratus", brand: "dodge", label: "Stratus", years: "1995 – 2006" },
  { id: "dodge-intrepid", brand: "dodge", label: "Intrepid", years: "1993 – 2004" },
  { id: "dodge-stealth", brand: "dodge", label: "Stealth", years: "1990 – 1996" },
  { id: "dodge-sprinter", brand: "dodge", label: "Sprinter", years: "2003 – 2009" },
  { id: "dodge-hornet", brand: "dodge", label: "Hornet", years: "2022 – present" },
  { id: "dodge-ram-promaster", brand: "dodge", label: "Ram ProMaster", years: "2014 – present" },
  // Renault: separate generations/body styles where replacement trim differs.
  { id: "renault-4", brand: "renault", label: "4", years: "1961 – 1992" },
  { id: "renault-5", brand: "renault", label: "5", years: "1972 – 1985" },
  { id: "renault-super-5", brand: "renault", label: "Super 5", years: "1984 – 1996" },
  { id: "renault-9", brand: "renault", label: "9", years: "1981 – 1989" },
  { id: "renault-11", brand: "renault", label: "11", years: "1983 – 1989" },
  { id: "renault-19", brand: "renault", label: "19", years: "1988 – 1996" },
  { id: "renault-21", brand: "renault", label: "21", years: "1986 – 1994" },
  { id: "renault-25", brand: "renault", label: "25", years: "1984 – 1992" },
  { id: "renault-clio-i", brand: "renault", label: "Clio I", years: "1990 – 1998" },
  { id: "renault-clio-ii", brand: "renault", label: "Clio II / Campus", years: "1998 – 2012" },
  { id: "renault-clio-iii", brand: "renault", label: "Clio III", years: "2005 – 2014" },
  { id: "renault-clio-iii-estate", brand: "renault", label: "Clio III Estate (Grandtour)", years: "2008 – 2014" },
  { id: "renault-clio-iv", brand: "renault", label: "Clio IV", years: "2012 – 2020" },
  { id: "renault-clio-iv-estate", brand: "renault", label: "Clio IV Estate (Grandtour)", years: "2013 – 2020" },
  { id: "renault-clio-v", brand: "renault", label: "Clio V", years: "2019 – 2025" },
  { id: "renault-twingo-i", brand: "renault", label: "Twingo I", years: "1993 – 2007" },
  { id: "renault-twingo-ii", brand: "renault", label: "Twingo II", years: "2007 – 2014" },
  { id: "renault-twingo-iii", brand: "renault", label: "Twingo III", years: "2014 – 2024" },
  { id: "renault-megane-i", brand: "renault", label: "Mégane I", years: "1995 – 2003" },
  { id: "renault-megane-i-estate", brand: "renault", label: "Mégane I Estate (Grandtour)", years: "1999 – 2003" },
  { id: "renault-megane-i-cabriolet", brand: "renault", label: "Mégane I Cabriolet", years: "1997 – 2003" },
  { id: "renault-megane-ii", brand: "renault", label: "Mégane II", years: "2002 – 2009" },
  { id: "renault-megane-ii-estate", brand: "renault", label: "Mégane II Estate (Grandtour)", years: "2003 – 2009" },
  { id: "renault-megane-ii-cc", brand: "renault", label: "Mégane II Coupé-Cabriolet", years: "2003 – 2010" },
  { id: "renault-megane-iii", brand: "renault", label: "Mégane III", years: "2008 – 2016" },
  { id: "renault-megane-iii-estate", brand: "renault", label: "Mégane III Estate (Grandtour)", years: "2009 – 2016" },
  { id: "renault-megane-iii-coupe", brand: "renault", label: "Mégane III Coupé", years: "2008 – 2016" },
  { id: "renault-megane-iii-cc", brand: "renault", label: "Mégane III Coupé-Cabriolet", years: "2010 – 2016" },
  { id: "renault-megane-iv", brand: "renault", label: "Mégane IV", years: "2016 – 2024" },
  { id: "renault-megane-iv-estate", brand: "renault", label: "Mégane IV Estate (Grandtour)", years: "2016 – 2024" },
  { id: "renault-scenic-i", brand: "renault", label: "Scénic I", years: "1996 – 2003" },
  { id: "renault-scenic-ii", brand: "renault", label: "Scénic II", years: "2003 – 2009" },
  { id: "renault-grand-scenic-ii", brand: "renault", label: "Grand Scénic II", years: "2004 – 2009" },
  { id: "renault-scenic-iii", brand: "renault", label: "Scénic III", years: "2009 – 2016" },
  { id: "renault-grand-scenic-iii", brand: "renault", label: "Grand Scénic III", years: "2009 – 2016" },
  { id: "renault-scenic-iv", brand: "renault", label: "Scénic IV", years: "2016 – 2022" },
  { id: "renault-grand-scenic-iv", brand: "renault", label: "Grand Scénic IV", years: "2016 – 2023" },
  { id: "renault-laguna-i", brand: "renault", label: "Laguna I", years: "1993 – 2001" },
  { id: "renault-laguna-i-estate", brand: "renault", label: "Laguna I Estate (Grandtour)", years: "1995 – 2001" },
  { id: "renault-laguna-ii", brand: "renault", label: "Laguna II", years: "2001 – 2007" },
  { id: "renault-laguna-ii-estate", brand: "renault", label: "Laguna II Estate (Grandtour)", years: "2001 – 2007" },
  { id: "renault-laguna-iii", brand: "renault", label: "Laguna III", years: "2007 – 2015" },
  { id: "renault-laguna-iii-estate", brand: "renault", label: "Laguna III Estate (Grandtour)", years: "2007 – 2015" },
  { id: "renault-laguna-iii-coupe", brand: "renault", label: "Laguna III Coupé", years: "2008 – 2015" },
  { id: "renault-safrane", brand: "renault", label: "Safrane", years: "1992 – 2000" },
  { id: "renault-vel-satis", brand: "renault", label: "Vel Satis", years: "2002 – 2009" },
  { id: "renault-talisman", brand: "renault", label: "Talisman", years: "2015 – 2022" },
  { id: "renault-talisman-estate", brand: "renault", label: "Talisman Estate (Grandtour)", years: "2016 – 2022" },
  { id: "renault-espace-i", brand: "renault", label: "Espace I", years: "1984 – 1991" },
  { id: "renault-espace-ii", brand: "renault", label: "Espace II", years: "1991 – 1996" },
  { id: "renault-espace-iii", brand: "renault", label: "Espace III / Grand Espace", years: "1996 – 2002" },
  { id: "renault-espace-iv", brand: "renault", label: "Espace IV / Grand Espace", years: "2002 – 2015" },
  { id: "renault-espace-v", brand: "renault", label: "Espace V", years: "2015 – 2023" },
  { id: "renault-espace-vi", brand: "renault", label: "Espace VI", years: "2023 – present" },
  { id: "renault-kangoo-i", brand: "renault", label: "Kangoo I", years: "1997 – 2008" },
  { id: "renault-kangoo-ii", brand: "renault", label: "Kangoo II", years: "2008 – 2021" },
  { id: "renault-kangoo-iii", brand: "renault", label: "Kangoo III", years: "2021 – present" },
  { id: "renault-modus", brand: "renault", label: "Modus", years: "2004 – 2012" },
  { id: "renault-grand-modus", brand: "renault", label: "Grand Modus", years: "2008 – 2012" },
  { id: "renault-captur-i", brand: "renault", label: "Captur I", years: "2013 – 2019" },
  { id: "renault-captur-ii", brand: "renault", label: "Captur II", years: "2019 – present" },
  { id: "renault-kadjar", brand: "renault", label: "Kadjar", years: "2015 – 2022" },
  { id: "renault-koleos-i", brand: "renault", label: "Koleos I", years: "2008 – 2016" },
  { id: "renault-koleos-ii", brand: "renault", label: "Koleos II", years: "2016 – 2023" },
  { id: "renault-austral", brand: "renault", label: "Austral", years: "2022 – present" },
  { id: "renault-arkana", brand: "renault", label: "Arkana (Europe)", years: "2021 – present" },
  { id: "renault-trafic-i", brand: "renault", label: "Trafic I", years: "1980 – 2001" },
  { id: "renault-trafic-ii", brand: "renault", label: "Trafic II", years: "2001 – 2014" },
  { id: "renault-trafic-iii", brand: "renault", label: "Trafic III", years: "2014 – present" },
  { id: "renault-master-i", brand: "renault", label: "Master I", years: "1980 – 1997" },
  { id: "renault-master-ii", brand: "renault", label: "Master II", years: "1997 – 2010" },
  { id: "renault-master-iii", brand: "renault", label: "Master III", years: "2010 – 2024" },
  { id: "renault-master-iv", brand: "renault", label: "Master IV", years: "2024 – present" },
  { id: "renault-fluence", brand: "renault", label: "Fluence", years: "2009 – 2018" },
  { id: "renault-wind", brand: "renault", label: "Wind", years: "2010 – 2013" },
  { id: "renault-zoe", brand: "renault", label: "Zoe", years: "2012 – 2024" },
  { id: "renault-megane-e-tech", brand: "renault", label: "Mégane E-Tech Electric", years: "2022 – present" },
  { id: "renault-scenic-e-tech", brand: "renault", label: "Scénic E-Tech Electric", years: "2024 – present" },
  { id: "renault-5-e-tech", brand: "renault", label: "5 E-Tech Electric", years: "2024 – present" },
  { id: "r129", brand: "mercedes", label: "R129 SL", years: "1989 – 2001" },
  { id: "r170", brand: "mercedes", label: "R170 SLK", years: "1996 – 2004" },
  { id: "r171", brand: "mercedes", label: "R171 SLK", years: "2004 – 2011" },
  { id: "r230", brand: "mercedes", label: "R230 SL", years: "2001 – 2012" },
  { id: "w126", brand: "mercedes", label: "W126 S-Class", years: "1979 – 1991" },
  { id: "w140", brand: "mercedes", label: "W140 S-Class", years: "1991 – 1998" },
  { id: "w163", brand: "mercedes", label: "W163 ML-Class", years: "1997 – 2005" },
  { id: "w164", brand: "mercedes", label: "W164 ML-Class", years: "2005 – 2011" },
  { id: "w166", brand: "mercedes", label: "W166 ML / GLE", years: "2011 – 2019" },
  { id: "w169", brand: "mercedes", label: "W169 A-Class", years: "2004 – 2012" },
  { id: "w176", brand: "mercedes", label: "W176 A-Class", years: "2012 – 2018" },
  { id: "w202", brand: "mercedes", label: "W202 C-Class", years: "1993 – 2000" },
  { id: "w203", brand: "mercedes", label: "203 C-Class Saloon", years: "2000 – 2007" },
  { id: "w204", brand: "mercedes", label: "204 C-Class Saloon", years: "2007 – 2014" },
  { id: "w205", brand: "mercedes", label: "205 C-Class Saloon", years: "2014 – 2021" },
  { id: "w209", brand: "mercedes", label: "209 CLK Coupé", years: "2002 – 2010" },
  { id: "w210", brand: "mercedes", label: "W210 E-Class", years: "1995 – 2003" },
  { id: "w211", brand: "mercedes", label: "211 E-Class Saloon", years: "2002 – 2009" },
  { id: "w212", brand: "mercedes", label: "212 E-Class Saloon", years: "2009 – 2016" },
  { id: "w213", brand: "mercedes", label: "213 E-Class Saloon", years: "2016 – 2023" },
  { id: "w218", brand: "mercedes", label: "218 CLS Coupé", years: "2011 – 2018" },
  { id: "w219", brand: "mercedes", label: "219 CLS Coupé", years: "2004 – 2010" },
  { id: "w220", brand: "mercedes", label: "W220 S-Class", years: "1998 – 2005" },
  { id: "w221", brand: "mercedes", label: "221 S-Class Saloon", years: "2005 – 2013" },
  { id: "w222", brand: "mercedes", label: "222 S-Class Saloon", years: "2013 – 2020" },
  { id: "w245", brand: "mercedes", label: "W245 B-Class", years: "2005 – 2011" },
  { id: "w246", brand: "mercedes", label: "W246 B-Class", years: "2011 – 2018" },
  { id: "w251", brand: "mercedes", label: "251 R-Class", years: "2005 – 2013" },
  { id: "w463", brand: "mercedes", label: "W463 G-Class", years: "1990 – 2018" },
  { id: "x164", brand: "mercedes", label: "X164 GL-Class", years: "2006 – 2012" },
  { id: "x204", brand: "mercedes", label: "X204 GLK-Class", years: "2008 – 2015" },
  { id: "w124", brand: "mercedes", label: "W124 E-Class", years: "1984 – 1997" },
  { id: "w201", brand: "mercedes", label: "W201 190E", years: "1982 – 1993" },
  { id: "w208", brand: "mercedes", label: "W208 CLK", years: "1997 – 2003" },
  // Mercedes-Benz — additional R series
  { id: "r107", brand: "mercedes", label: "R107 SL / SLC", years: "1971 – 1989" },
  { id: "r172", brand: "mercedes", label: "R172 SLK / SLC", years: "2011 – 2020" },
  { id: "r197", brand: "mercedes", label: "R197 SLS AMG Roadster", years: "2011 – 2014" },
  { id: "r199", brand: "mercedes", label: "R199 SLR McLaren Roadster", years: "2007 – 2009" },
  { id: "r231", brand: "mercedes", label: "R231 SL", years: "2012 – 2020" },
  { id: "r232", brand: "mercedes", label: "R232 SL AMG", years: "2021 – present" },
  // Mercedes-Benz — additional W series (classics)
  { id: "w108", brand: "mercedes", label: "W108 S-Class", years: "1965 – 1972" },
  { id: "w109", brand: "mercedes", label: "W109 S-Class LWB", years: "1965 – 1972" },
  { id: "w111", brand: "mercedes", label: "W111 Fintail / Coupé", years: "1959 – 1971" },
  { id: "w113", brand: "mercedes", label: "W113 SL Pagoda", years: "1963 – 1971" },
  { id: "w114", brand: "mercedes", label: "W114 (250 / 280)", years: "1968 – 1976" },
  { id: "w115", brand: "mercedes", label: "W115 (200 – 240D)", years: "1968 – 1976" },
  { id: "w116", brand: "mercedes", label: "W116 S-Class", years: "1972 – 1980" },
  { id: "w123", brand: "mercedes", label: "W123 E-Class", years: "1975 – 1986" },
  // Mercedes-Benz — additional W series (modern)
  { id: "w167", brand: "mercedes", label: "W167 GLE", years: "2019 – present" },
  { id: "w168", brand: "mercedes", label: "W168 A-Class", years: "1997 – 2004" },
  { id: "w177", brand: "mercedes", label: "W177 A-Class", years: "2018 – present" },
  { id: "w206", brand: "mercedes", label: "W206 C-Class", years: "2021 – present" },
  { id: "w207", brand: "mercedes", label: "W207 E-Class Coupé", years: "2009 – 2017" },
  { id: "w214", brand: "mercedes", label: "W214 E-Class", years: "2023 – present" },
  { id: "w215", brand: "mercedes", label: "W215 CL-Class", years: "1999 – 2006" },
  { id: "w216", brand: "mercedes", label: "W216 CL-Class", years: "2006 – 2014" },
  { id: "w217", brand: "mercedes", label: "W217 S-Class Coupé", years: "2014 – 2020" },
  { id: "w223", brand: "mercedes", label: "W223 S-Class", years: "2020 – present" },
  { id: "w247", brand: "mercedes", label: "W247 B-Class", years: "2018 – present" },
  // Mercedes-Benz — vans
  { id: "w414", brand: "mercedes", label: "W414 Vaneo", years: "2002 – 2005" },
  { id: "w639", brand: "mercedes", label: "W639 Vito / Viano", years: "2003 – 2014" },
  { id: "w447", brand: "mercedes", label: "W447 Vito / V-Class", years: "2014 – present" },
  { id: "w906", brand: "mercedes", label: "W906 Sprinter", years: "2006 – 2018" },
  { id: "w907", brand: "mercedes", label: "W907 Sprinter", years: "2018 – present" },

  // BMW — E series
  { id: "e12", brand: "bmw", label: "E12 5-Series", years: "1972 – 1981" },
  { id: "e21", brand: "bmw", label: "E21 3-Series", years: "1975 – 1983" },
  { id: "e23", brand: "bmw", label: "E23 7-Series", years: "1977 – 1986" },
  { id: "e24", brand: "bmw", label: "E24 6-Series", years: "1976 – 1989" },
  { id: "e28", brand: "bmw", label: "E28 5-Series", years: "1981 – 1988" },
  { id: "e30", brand: "bmw", label: "E30 3-Series", years: "1982 – 1994" },
  { id: "e31", brand: "bmw", label: "E31 8-Series", years: "1989 – 1999" },
  { id: "e32", brand: "bmw", label: "E32 7-Series", years: "1986 – 1994" },
  { id: "e34", brand: "bmw", label: "E34 5-Series", years: "1988 – 1996" },
  { id: "e36", brand: "bmw", label: "E36 3-Series", years: "1990 – 2000" },
  { id: "e38", brand: "bmw", label: "E38 7-Series", years: "1994 – 2001" },
  { id: "e39", brand: "bmw", label: "E39 5-Series", years: "1995 – 2004" },
  { id: "e46", brand: "bmw", label: "E46 3-Series", years: "1997 – 2006" },
  { id: "e52", brand: "bmw", label: "E52 Z8", years: "1999 – 2003" },
  { id: "e53", brand: "bmw", label: "E53 X5", years: "1999 – 2006" },
  { id: "e60", brand: "bmw", label: "E60 5-Series Saloon", years: "2003 – 2010" },
  { id: "e61", brand: "bmw", label: "E61 5-Series Touring", years: "2004 – 2010" },
  { id: "e63", brand: "bmw", label: "E63 6-Series Coupé", years: "2003 – 2010" },
  { id: "e64", brand: "bmw", label: "E64 6-Series Cabrio", years: "2004 – 2010" },
  { id: "e65", brand: "bmw", label: "E65 7-Series", years: "2001 – 2008" },
  { id: "e66", brand: "bmw", label: "E66 7-Series LWB", years: "2001 – 2008" },
  { id: "e70", brand: "bmw", label: "E70 X5", years: "2006 – 2013" },
  { id: "e71", brand: "bmw", label: "E71 X6", years: "2008 – 2014" },
  { id: "e72", brand: "bmw", label: "E72 X6 ActiveHybrid", years: "2009 – 2011" },
  { id: "e81", brand: "bmw", label: "E81 1-Series 3-door", years: "2007 – 2012" },
  { id: "e82", brand: "bmw", label: "E82 1-Series Coupé", years: "2007 – 2013" },
  { id: "e83", brand: "bmw", label: "E83 X3", years: "2003 – 2010" },
  { id: "e84", brand: "bmw", label: "E84 X1", years: "2009 – 2015" },
  { id: "e85", brand: "bmw", label: "E85 Z4 Roadster", years: "2002 – 2008" },
  { id: "e86", brand: "bmw", label: "E86 Z4 Coupé", years: "2006 – 2008" },
  { id: "e87", brand: "bmw", label: "E87 1-Series 5-door", years: "2004 – 2011" },
  { id: "e88", brand: "bmw", label: "E88 1-Series Cabrio", years: "2008 – 2013" },
  { id: "e89", brand: "bmw", label: "E89 Z4", years: "2009 – 2016" },
  { id: "e90", brand: "bmw", label: "E90 3-Series Saloon", years: "2004 – 2011" },
  { id: "e91", brand: "bmw", label: "E91 3-Series Touring", years: "2005 – 2012" },
  { id: "e92", brand: "bmw", label: "E92 3-Series Coupé", years: "2006 – 2013" },
  { id: "e93", brand: "bmw", label: "E93 3-Series Cabrio", years: "2007 – 2013" },
  // BMW — F series
  { id: "f01", brand: "bmw", label: "F01 7-Series", years: "2008 – 2015" },
  { id: "f02", brand: "bmw", label: "F02 7-Series LWB", years: "2008 – 2015" },
  { id: "f06", brand: "bmw", label: "F06 6-Series Gran Coupé", years: "2012 – 2018" },
  { id: "f07", brand: "bmw", label: "F07 5-Series GT", years: "2009 – 2017" },
  { id: "f10", brand: "bmw", label: "F10 5-Series Saloon", years: "2010 – 2017" },
  { id: "f11", brand: "bmw", label: "F11 5-Series Touring", years: "2010 – 2017" },
  { id: "f12", brand: "bmw", label: "F12 6-Series Cabrio", years: "2011 – 2018" },
  { id: "f13", brand: "bmw", label: "F13 6-Series Coupé", years: "2011 – 2018" },
  { id: "f15", brand: "bmw", label: "F15 X5", years: "2013 – 2018" },
  { id: "f16", brand: "bmw", label: "F16 X6", years: "2014 – 2019" },
  { id: "f20", brand: "bmw", label: "F20 1-Series 5-door", years: "2011 – 2019" },
  { id: "f21", brand: "bmw", label: "F21 1-Series 3-door", years: "2012 – 2019" },
  { id: "f22", brand: "bmw", label: "F22 2-Series Coupé", years: "2014 – 2021" },
  { id: "f23", brand: "bmw", label: "F23 2-Series Cabrio", years: "2015 – 2021" },
  { id: "f25", brand: "bmw", label: "F25 X3", years: "2010 – 2017" },
  { id: "f26", brand: "bmw", label: "F26 X4", years: "2014 – 2018" },
  { id: "f30", brand: "bmw", label: "F30 3-Series Saloon", years: "2011 – 2019" },
  { id: "f31", brand: "bmw", label: "F31 3-Series Touring", years: "2012 – 2019" },
  { id: "f32", brand: "bmw", label: "F32 4-Series Coupé", years: "2013 – 2020" },
  { id: "f33", brand: "bmw", label: "F33 4-Series Cabrio", years: "2014 – 2020" },
  { id: "f34", brand: "bmw", label: "F34 3-Series GT", years: "2013 – 2020" },
  { id: "f36", brand: "bmw", label: "F36 4-Series Gran Coupé", years: "2014 – 2020" },
  { id: "f39", brand: "bmw", label: "F39 X2", years: "2017 – 2023" },
  { id: "f40", brand: "bmw", label: "F40 1-Series", years: "2019 – 2024" },
  { id: "f44", brand: "bmw", label: "F44 2-Series Gran Coupé", years: "2019 – present" },
  { id: "f45", brand: "bmw", label: "F45 2-Series Active Tourer", years: "2014 – 2021" },
  { id: "f46", brand: "bmw", label: "F46 2-Series Gran Tourer", years: "2015 – 2022" },
  { id: "f48", brand: "bmw", label: "F48 X1", years: "2015 – 2022" },
  { id: "f52", brand: "bmw", label: "F52 1-Series Saloon", years: "2017 – 2022" },
  { id: "f54", brand: "bmw", label: "F54 Mini Clubman", years: "2015 – 2024" },
  { id: "f55", brand: "bmw", label: "F55 Mini 5-door", years: "2014 – 2024" },
  { id: "f56", brand: "bmw", label: "F56 Mini 3-door", years: "2014 – 2024" },
  { id: "f57", brand: "bmw", label: "F57 Mini Cabrio", years: "2016 – 2024" },
  { id: "f80", brand: "bmw", label: "F80 M3", years: "2014 – 2018" },
  { id: "f82", brand: "bmw", label: "F82 M4 Coupé", years: "2014 – 2020" },
  { id: "f83", brand: "bmw", label: "F83 M4 Cabrio", years: "2014 – 2020" },
  { id: "f85", brand: "bmw", label: "F85 X5 M", years: "2015 – 2018" },
  { id: "f86", brand: "bmw", label: "F86 X6 M", years: "2015 – 2019" },
  { id: "f87", brand: "bmw", label: "F87 M2", years: "2016 – 2021" },
  { id: "f90", brand: "bmw", label: "F90 M5", years: "2017 – 2023" },
  // BMW — Z series
  { id: "z1", brand: "bmw", label: "Z1 Roadster", years: "1988 – 1991" },
  { id: "z3", brand: "bmw", label: "E36/7 Z3", years: "1995 – 2002" },
  // Volkswagen — Golf
  { id: "vw-golf-mk1", brand: "volkswagen", label: "Golf Mk1", years: "1974 – 1983" },
  { id: "vw-golf-mk2", brand: "volkswagen", label: "Golf Mk2", years: "1983 – 1992" },
  { id: "vw-golf-mk3", brand: "volkswagen", label: "Golf Mk3", years: "1991 – 1999" },
  { id: "vw-golf-mk4", brand: "volkswagen", label: "Golf Mk4", years: "1997 – 2006" },
  { id: "vw-golf-mk5", brand: "volkswagen", label: "Golf Mk5", years: "2003 – 2009" },
  { id: "vw-golf-mk6", brand: "volkswagen", label: "Golf Mk6", years: "2008 – 2013" },
  { id: "vw-golf-mk7", brand: "volkswagen", label: "Golf Mk7", years: "2012 – 2020" },
  { id: "vw-golf-mk8", brand: "volkswagen", label: "Golf Mk8", years: "2019 – present" },
  // Volkswagen — Jetta / Vento / Bora
  { id: "vw-jetta-mk1", brand: "volkswagen", label: "Jetta Mk1 (A1)", years: "1979 – 1984" },
  { id: "vw-jetta-mk2", brand: "volkswagen", label: "Jetta Mk2 (A2)", years: "1984 – 1992" },
  { id: "vw-jetta-mk3", brand: "volkswagen", label: "Jetta Mk3 / Vento (1H)", years: "1992 – 1999" },
  { id: "vw-jetta-mk4", brand: "volkswagen", label: "Jetta Mk4 (1J)", years: "1998 – 2005" },

  { id: "vw-bora", brand: "volkswagen", label: "Bora", years: "1998 – 2005" },
  { id: "vw-jetta-mk5", brand: "volkswagen", label: "Jetta Mk5", years: "2005 – 2010" },
  { id: "vw-jetta-mk6", brand: "volkswagen", label: "Jetta Mk6", years: "2010 – 2018" },
  // Volkswagen — Passat & co
  { id: "vw-passat-b1", brand: "volkswagen", label: "Passat B1", years: "1973 – 1980" },
  { id: "vw-passat-b2", brand: "volkswagen", label: "Passat B2", years: "1981 – 1988" },
  { id: "vw-passat-b3", brand: "volkswagen", label: "Passat B3", years: "1988 – 1993" },
  { id: "vw-passat-b4", brand: "volkswagen", label: "Passat B4", years: "1993 – 1997" },
  { id: "vw-passat-b5", brand: "volkswagen", label: "Passat B5 / B5.5", years: "1996 – 2005" },
  { id: "vw-passat-b6", brand: "volkswagen", label: "Passat B6", years: "2005 – 2010" },
  { id: "vw-passat-b7", brand: "volkswagen", label: "Passat B7", years: "2010 – 2015" },
  { id: "vw-passat-b8", brand: "volkswagen", label: "Passat B8", years: "2014 – 2023" },
  { id: "vw-cc", brand: "volkswagen", label: "Passat CC", years: "2008 – 2017" },
  { id: "vw-arteon", brand: "volkswagen", label: "Arteon", years: "2017 – 2024" },
  // Volkswagen — small cars
  { id: "vw-polo-mk3", brand: "volkswagen", label: "Polo Mk3 (6N)", years: "1994 – 2002" },
  { id: "vw-polo-mk4", brand: "volkswagen", label: "Polo Mk4 (9N)", years: "2001 – 2009" },
  { id: "vw-polo-mk5", brand: "volkswagen", label: "Polo Mk5 (6R/6C)", years: "2009 – 2017" },
  { id: "vw-polo-mk6", brand: "volkswagen", label: "Polo Mk6 (AW)", years: "2017 – present" },
  { id: "vw-lupo", brand: "volkswagen", label: "Lupo", years: "1998 – 2005" },
  { id: "vw-fox", brand: "volkswagen", label: "Fox", years: "2005 – 2011" },
  { id: "vw-up", brand: "volkswagen", label: "up!", years: "2011 – 2023" },
  // Volkswagen — coupés & cabrios
  { id: "vw-scirocco-mk1", brand: "volkswagen", label: "Scirocco Mk1", years: "1974 – 1981" },
  { id: "vw-scirocco-mk2", brand: "volkswagen", label: "Scirocco Mk2", years: "1981 – 1992" },
  { id: "vw-corrado", brand: "volkswagen", label: "Corrado", years: "1988 – 1995" },
  { id: "vw-scirocco-mk3", brand: "volkswagen", label: "Scirocco Mk3", years: "2008 – 2017" },
  { id: "vw-beetle-classic", brand: "volkswagen", label: "Beetle (Käfer, classic)", years: "1970 – 2003" },
  { id: "vw-beetle-a4", brand: "volkswagen", label: "New Beetle (A4)", years: "1997 – 2011" },
  { id: "vw-beetle-a5", brand: "volkswagen", label: "Beetle (A5)", years: "2011 – 2019" },
  { id: "vw-eos", brand: "volkswagen", label: "Eos", years: "2006 – 2015" },
  { id: "vw-phaeton", brand: "volkswagen", label: "Phaeton", years: "2002 – 2016" },
  // Volkswagen — MPV & vans
  { id: "vw-touran-1t", brand: "volkswagen", label: "Touran (1T)", years: "2003 – 2015" },
  { id: "vw-touran-5t", brand: "volkswagen", label: "Touran (5T)", years: "2015 – present" },
  { id: "vw-sharan-7m", brand: "volkswagen", label: "Sharan (7M)", years: "1995 – 2010" },
  { id: "vw-sharan-7n", brand: "volkswagen", label: "Sharan (7N)", years: "2010 – 2022" },
  { id: "vw-caddy-2k", brand: "volkswagen", label: "Caddy (2K)", years: "2003 – 2020" },
  { id: "vw-caddy-sb", brand: "volkswagen", label: "Caddy (SB)", years: "2020 – present" },
  { id: "vw-t4", brand: "volkswagen", label: "Transporter T4", years: "1990 – 2003" },
  { id: "vw-t5", brand: "volkswagen", label: "Transporter T5", years: "2003 – 2015" },
  { id: "vw-t6", brand: "volkswagen", label: "Transporter T6 / T6.1", years: "2015 – present" },
  // Volkswagen — SUV & EV
  { id: "vw-tiguan-5n", brand: "volkswagen", label: "Tiguan (5N)", years: "2007 – 2016" },
  { id: "vw-tiguan-ad", brand: "volkswagen", label: "Tiguan (AD/BW)", years: "2016 – 2023" },
  { id: "vw-t-roc", brand: "volkswagen", label: "T-Roc", years: "2017 – present" },
  { id: "vw-t-cross", brand: "volkswagen", label: "T-Cross", years: "2018 – present" },
  { id: "vw-touareg-7l", brand: "volkswagen", label: "Touareg (7L)", years: "2002 – 2010" },
  { id: "vw-touareg-7p", brand: "volkswagen", label: "Touareg (7P)", years: "2010 – 2018" },
  { id: "vw-touareg-cr", brand: "volkswagen", label: "Touareg (CR)", years: "2018 – present" },
  { id: "vw-amarok", brand: "volkswagen", label: "Amarok", years: "2010 – present" },
  { id: "vw-id3", brand: "volkswagen", label: "ID.3", years: "2019 – present" },
  { id: "vw-id4", brand: "volkswagen", label: "ID.4", years: "2020 – present" },

  // Audi — classic (1970s–1980s)
  { id: "audi-80-b1", brand: "audi", label: "80 (B1)", years: "1972 – 1978" },
  { id: "audi-80-b2", brand: "audi", label: "80 (B2)", years: "1978 – 1986" },
  { id: "audi-90-b2", brand: "audi", label: "90 (B2)", years: "1984 – 1987" },
  { id: "audi-90-b3", brand: "audi", label: "90 (B3)", years: "1987 – 1991" },
  { id: "audi-100-c1", brand: "audi", label: "100 (C1)", years: "1968 – 1976" },
  { id: "audi-100-c2", brand: "audi", label: "100 (C2)", years: "1976 – 1982" },
  { id: "audi-100-c3", brand: "audi", label: "100 (C3)", years: "1982 – 1991" },
  { id: "audi-100-c4", brand: "audi", label: "100 / A6 (C4)", years: "1990 – 1997" },
  // Audi
  { id: "audi-80-b3", brand: "audi", label: "80 (B3)", years: "1986 – 1991" },
  { id: "audi-80-b4", brand: "audi", label: "80 (B4)", years: "1991 – 1996" },
  { id: "audi-a1-8x", brand: "audi", label: "A1 (8X)", years: "2010 – 2018" },
  { id: "audi-a1-gb", brand: "audi", label: "A1 (GB)", years: "2018 – present" },
  { id: "audi-a3-8l", brand: "audi", label: "A3 (8L)", years: "1996 – 2003" },
  { id: "audi-a3-8p", brand: "audi", label: "A3 (8P)", years: "2003 – 2013" },
  { id: "audi-a3-8v", brand: "audi", label: "A3 (8V)", years: "2012 – 2020" },
  { id: "audi-a3-8y", brand: "audi", label: "A3 (8Y)", years: "2020 – present" },
  { id: "audi-a4-b5", brand: "audi", label: "A4 (B5)", years: "1994 – 2001" },
  { id: "audi-a4-b6", brand: "audi", label: "A4 (B6)", years: "2000 – 2004" },
  { id: "audi-a4-b7", brand: "audi", label: "A4 (B7)", years: "2004 – 2008" },
  { id: "audi-a4-b8", brand: "audi", label: "A4 (B8)", years: "2007 – 2015" },
  { id: "audi-a4-b9", brand: "audi", label: "A4 (B9)", years: "2015 – present" },
  { id: "audi-a5-8t", brand: "audi", label: "A5 (8T)", years: "2007 – 2016" },
  { id: "audi-a5-f5", brand: "audi", label: "A5 (F5)", years: "2016 – present" },
  { id: "audi-a6-c4", brand: "audi", label: "A6 (C4)", years: "1994 – 1997" },
  { id: "audi-a6-c5", brand: "audi", label: "A6 (C5)", years: "1997 – 2004" },
  { id: "audi-a6-c6", brand: "audi", label: "A6 (C6)", years: "2004 – 2011" },
  { id: "audi-a6-c7", brand: "audi", label: "A6 (C7)", years: "2011 – 2018" },
  { id: "audi-a6-c8", brand: "audi", label: "A6 (C8)", years: "2018 – present" },
  { id: "audi-a7-4g", brand: "audi", label: "A7 (4G)", years: "2010 – 2018" },
  { id: "audi-a7-4k", brand: "audi", label: "A7 (4K)", years: "2018 – present" },
  { id: "audi-a8-d2", brand: "audi", label: "A8 (D2)", years: "1994 – 2002" },
  { id: "audi-a8-d3", brand: "audi", label: "A8 (D3)", years: "2002 – 2010" },
  { id: "audi-a8-d4", brand: "audi", label: "A8 (D4)", years: "2010 – 2017" },
  { id: "audi-a8-d5", brand: "audi", label: "A8 (D5)", years: "2017 – present" },
  { id: "audi-q2", brand: "audi", label: "Q2 (GA)", years: "2016 – present" },
  { id: "audi-q3-8u", brand: "audi", label: "Q3 (8U)", years: "2011 – 2018" },
  { id: "audi-q3-f3", brand: "audi", label: "Q3 (F3)", years: "2018 – present" },
  { id: "audi-q5-8r", brand: "audi", label: "Q5 (8R)", years: "2008 – 2017" },
  { id: "audi-q5-fy", brand: "audi", label: "Q5 (FY)", years: "2017 – present" },
  { id: "audi-q7-4l", brand: "audi", label: "Q7 (4L)", years: "2005 – 2015" },
  { id: "audi-q7-4m", brand: "audi", label: "Q7 (4M)", years: "2015 – present" },
  { id: "audi-tt-8n", brand: "audi", label: "TT (8N)", years: "1998 – 2006" },
  { id: "audi-tt-8j", brand: "audi", label: "TT (8J)", years: "2006 – 2014" },
  { id: "audi-tt-8s", brand: "audi", label: "TT (8S)", years: "2014 – 2023" },
  { id: "audi-r8-42", brand: "audi", label: "R8 (Type 42)", years: "2006 – 2015" },
  { id: "audi-r8-4s", brand: "audi", label: "R8 (Type 4S)", years: "2015 – 2024" },

  // Mini
  { id: "mini-r50", brand: "mini", label: "R50 One / Cooper", years: "2001 – 2006" },
  { id: "mini-r52", brand: "mini", label: "R52 Cabrio", years: "2004 – 2008" },
  { id: "mini-r53", brand: "mini", label: "R53 Cooper S", years: "2001 – 2006" },
  { id: "mini-r55", brand: "mini", label: "R55 Clubman", years: "2007 – 2014" },
  { id: "mini-r56", brand: "mini", label: "R56 Hatch", years: "2006 – 2013" },
  { id: "mini-r57", brand: "mini", label: "R57 Cabrio", years: "2009 – 2015" },
  { id: "mini-r58", brand: "mini", label: "R58 Coupé", years: "2011 – 2015" },
  { id: "mini-r59", brand: "mini", label: "R59 Roadster", years: "2012 – 2015" },
  { id: "mini-r60", brand: "mini", label: "R60 Countryman", years: "2010 – 2016" },
  { id: "mini-r61", brand: "mini", label: "R61 Paceman", years: "2012 – 2016" },
  { id: "mini-f54", brand: "mini", label: "F54 Clubman", years: "2015 – 2024" },
  { id: "mini-f55", brand: "mini", label: "F55 5-door", years: "2014 – 2024" },
  { id: "mini-f56", brand: "mini", label: "F56 3-door", years: "2014 – 2024" },
  { id: "mini-f57", brand: "mini", label: "F57 Cabrio", years: "2016 – 2024" },
  { id: "mini-f60", brand: "mini", label: "F60 Countryman", years: "2017 – 2023" },
  { id: "mini-classic", brand: "mini", label: "Classic Mini", years: "1959 – 2000" },

  // Jeep
  { id: "jeep-cj", brand: "jeep", label: "CJ", years: "1944 – 1986" },
  { id: "jeep-yj", brand: "jeep", label: "Wrangler YJ", years: "1986 – 1995" },
  { id: "jeep-tj", brand: "jeep", label: "Wrangler TJ", years: "1996 – 2006" },
  { id: "jeep-jk", brand: "jeep", label: "Wrangler JK", years: "2006 – 2018" },
  { id: "jeep-jl", brand: "jeep", label: "Wrangler JL", years: "2018 – present" },
  { id: "jeep-xj", brand: "jeep", label: "Cherokee XJ", years: "1984 – 2001" },
  { id: "jeep-kj", brand: "jeep", label: "Cherokee / Liberty KJ", years: "2001 – 2007" },
  { id: "jeep-kk", brand: "jeep", label: "Cherokee / Liberty KK", years: "2008 – 2012" },
  { id: "jeep-kl", brand: "jeep", label: "Cherokee KL", years: "2013 – 2023" },
  { id: "jeep-zj", brand: "jeep", label: "Grand Cherokee ZJ", years: "1992 – 1998" },
  { id: "jeep-wj", brand: "jeep", label: "Grand Cherokee WJ", years: "1998 – 2004" },
  { id: "jeep-wk", brand: "jeep", label: "Grand Cherokee WK", years: "2004 – 2010" },
  { id: "jeep-wk2", brand: "jeep", label: "Grand Cherokee WK2", years: "2010 – 2021" },
  { id: "jeep-wl", brand: "jeep", label: "Grand Cherokee WL", years: "2021 – present" },
  { id: "jeep-compass-mk", brand: "jeep", label: "Compass (MK)", years: "2006 – 2016" },
  { id: "jeep-compass-mp", brand: "jeep", label: "Compass (MP)", years: "2017 – present" },
  { id: "jeep-renegade", brand: "jeep", label: "Renegade (BU)", years: "2014 – present" },

  // Porsche — classic front-engine & air-cooled
  { id: "porsche-924", brand: "porsche", label: "924", years: "1976 – 1988" },
  { id: "porsche-944", brand: "porsche", label: "944 / 944S / 944 Turbo", years: "1982 – 1991" },
  { id: "porsche-968", brand: "porsche", label: "968", years: "1991 – 1995" },
  { id: "porsche-928", brand: "porsche", label: "928", years: "1977 – 1995" },
  { id: "porsche-911-g", brand: "porsche", label: "911 (G-Series)", years: "1973 – 1989" },
  { id: "porsche-911-930", brand: "porsche", label: "911 Turbo (930)", years: "1974 – 1989" },
  // Porsche — modern
  { id: "porsche-911-964", brand: "porsche", label: "911 (964)", years: "1989 – 1994" },
  { id: "porsche-911-993", brand: "porsche", label: "911 (993)", years: "1993 – 1998" },
  { id: "porsche-911-996", brand: "porsche", label: "911 (996)", years: "1997 – 2005" },
  { id: "porsche-911-997", brand: "porsche", label: "911 (997)", years: "2004 – 2012" },
  { id: "porsche-911-991", brand: "porsche", label: "911 (991)", years: "2011 – 2019" },
  { id: "porsche-911-992", brand: "porsche", label: "911 (992)", years: "2019 – present" },
  { id: "porsche-boxster-986", brand: "porsche", label: "Boxster (986)", years: "1996 – 2004" },
  { id: "porsche-boxster-987", brand: "porsche", label: "Boxster / Cayman (987)", years: "2004 – 2012" },
  { id: "porsche-981", brand: "porsche", label: "Boxster / Cayman (981)", years: "2012 – 2016" },
  { id: "porsche-982", brand: "porsche", label: "718 (982)", years: "2016 – present" },
  { id: "porsche-cayenne-955", brand: "porsche", label: "Cayenne (955/957)", years: "2002 – 2010" },
  { id: "porsche-cayenne-958", brand: "porsche", label: "Cayenne (958)", years: "2010 – 2017" },
  { id: "porsche-cayenne-9ya", brand: "porsche", label: "Cayenne (9YA)", years: "2017 – present" },
  { id: "porsche-macan", brand: "porsche", label: "Macan (95B)", years: "2014 – present" },
  { id: "porsche-panamera-970", brand: "porsche", label: "Panamera (970)", years: "2009 – 2016" },
  { id: "porsche-panamera-971", brand: "porsche", label: "Panamera (971)", years: "2016 – present" },

  // Opel
  { id: "opel-astra-f", brand: "opel", label: "Astra F", years: "1991 – 1998" },
  { id: "opel-astra-g", brand: "opel", label: "Astra G", years: "1998 – 2004" },
  { id: "opel-astra-h", brand: "opel", label: "Astra H", years: "2004 – 2010" },
  { id: "opel-astra-j", brand: "opel", label: "Astra J", years: "2009 – 2015" },
  { id: "opel-astra-k", brand: "opel", label: "Astra K", years: "2015 – 2021" },
  { id: "opel-corsa-b", brand: "opel", label: "Corsa B", years: "1993 – 2000" },
  { id: "opel-corsa-c", brand: "opel", label: "Corsa C", years: "2000 – 2006" },
  { id: "opel-corsa-d", brand: "opel", label: "Corsa D", years: "2006 – 2014" },
  { id: "opel-corsa-e", brand: "opel", label: "Corsa E", years: "2014 – 2019" },
  { id: "opel-vectra-b", brand: "opel", label: "Vectra B", years: "1995 – 2002" },
  { id: "opel-vectra-c", brand: "opel", label: "Vectra C", years: "2002 – 2008" },
  { id: "opel-insignia-a", brand: "opel", label: "Insignia A", years: "2008 – 2017" },
  { id: "opel-insignia-b", brand: "opel", label: "Insignia B", years: "2017 – 2022" },
  { id: "opel-zafira-a", brand: "opel", label: "Zafira A", years: "1999 – 2005" },
  { id: "opel-zafira-b", brand: "opel", label: "Zafira B", years: "2005 – 2014" },
  { id: "opel-meriva-a", brand: "opel", label: "Meriva A", years: "2003 – 2010" },
  { id: "opel-mokka", brand: "opel", label: "Mokka", years: "2012 – 2019" },
  { id: "opel-omega-b", brand: "opel", label: "Omega B", years: "1994 – 2003" },

  // Ford
  { id: "ford-fiesta-mk5", brand: "ford", label: "Fiesta Mk5", years: "2002 – 2008" },
  { id: "ford-fiesta-mk6", brand: "ford", label: "Fiesta Mk6", years: "2008 – 2017" },
  { id: "ford-fiesta-mk7", brand: "ford", label: "Fiesta Mk7", years: "2017 – 2023" },
  { id: "ford-focus-mk1", brand: "ford", label: "Focus Mk1", years: "1998 – 2004" },
  { id: "ford-focus-mk2", brand: "ford", label: "Focus Mk2", years: "2004 – 2011" },
  { id: "ford-focus-mk3", brand: "ford", label: "Focus Mk3", years: "2011 – 2018" },
  { id: "ford-focus-mk4", brand: "ford", label: "Focus Mk4", years: "2018 – present" },
  { id: "ford-mondeo-mk3", brand: "ford", label: "Mondeo Mk3", years: "2000 – 2007" },
  { id: "ford-mondeo-mk4", brand: "ford", label: "Mondeo Mk4", years: "2007 – 2014" },
  { id: "ford-mondeo-mk5", brand: "ford", label: "Mondeo Mk5", years: "2014 – 2022" },
  { id: "ford-kuga-mk1", brand: "ford", label: "Kuga Mk1", years: "2008 – 2012" },
  { id: "ford-kuga-mk2", brand: "ford", label: "Kuga Mk2", years: "2012 – 2019" },
  { id: "ford-transit-mk7", brand: "ford", label: "Transit Mk7", years: "2006 – 2013" },
  { id: "ford-transit-custom", brand: "ford", label: "Transit Custom", years: "2012 – present" },
  { id: "ford-mustang-s197", brand: "ford", label: "Mustang (S197)", years: "2005 – 2014" },
  { id: "ford-mustang-s550", brand: "ford", label: "Mustang (S550)", years: "2015 – 2023" },

  // Seat
  { id: "seat-ibiza-6l", brand: "seat", label: "Ibiza (6L)", years: "2002 – 2008" },
  { id: "seat-ibiza-6j", brand: "seat", label: "Ibiza (6J)", years: "2008 – 2017" },
  { id: "seat-ibiza-kj", brand: "seat", label: "Ibiza (KJ)", years: "2017 – present" },
  { id: "seat-leon-1m", brand: "seat", label: "Leon (1M)", years: "1999 – 2006" },
  { id: "seat-leon-1p", brand: "seat", label: "Leon (1P)", years: "2005 – 2012" },
  { id: "seat-leon-5f", brand: "seat", label: "Leon (5F)", years: "2012 – 2020" },
  { id: "seat-leon-kl", brand: "seat", label: "Leon (KL)", years: "2020 – present" },
  { id: "seat-altea", brand: "seat", label: "Altea", years: "2004 – 2015" },
  { id: "seat-toledo-1m", brand: "seat", label: "Toledo (1M)", years: "1998 – 2004" },
  { id: "seat-ateca", brand: "seat", label: "Ateca", years: "2016 – present" },

  // Škoda
  { id: "skoda-octavia-1u", brand: "skoda", label: "Octavia I (1U)", years: "1996 – 2010" },
  { id: "skoda-octavia-1z", brand: "skoda", label: "Octavia II (1Z)", years: "2004 – 2013" },
  { id: "skoda-octavia-5e", brand: "skoda", label: "Octavia III (5E)", years: "2012 – 2020" },
  { id: "skoda-octavia-nx", brand: "skoda", label: "Octavia IV (NX)", years: "2019 – present" },
  { id: "skoda-fabia-6y", brand: "skoda", label: "Fabia I (6Y)", years: "1999 – 2007" },
  { id: "skoda-fabia-5j", brand: "skoda", label: "Fabia II (5J)", years: "2007 – 2014" },
  { id: "skoda-fabia-nj", brand: "skoda", label: "Fabia III (NJ)", years: "2014 – 2021" },
  { id: "skoda-superb-3u", brand: "skoda", label: "Superb I (3U)", years: "2001 – 2008" },
  { id: "skoda-superb-3t", brand: "skoda", label: "Superb II (3T)", years: "2008 – 2015" },
  { id: "skoda-superb-3v", brand: "skoda", label: "Superb III (3V)", years: "2015 – present" },
  { id: "skoda-yeti", brand: "skoda", label: "Yeti", years: "2009 – 2017" },
  { id: "skoda-kodiaq", brand: "skoda", label: "Kodiaq", years: "2016 – present" },
  { id: "skoda-karoq", brand: "skoda", label: "Karoq", years: "2017 – present" },

  // Volvo
  { id: "volvo-240", brand: "volvo", label: "240", years: "1974 – 1993" },
  { id: "volvo-850", brand: "volvo", label: "850", years: "1991 – 1997" },
  { id: "volvo-s40-v40-1", brand: "volvo", label: "S40 / V40 (1st)", years: "1995 – 2004" },
  { id: "volvo-s60-1", brand: "volvo", label: "S60 (1st)", years: "2000 – 2009" },
  { id: "volvo-s60-2", brand: "volvo", label: "S60 (2nd)", years: "2010 – 2018" },
  { id: "volvo-v70-2", brand: "volvo", label: "V70 (2nd)", years: "2000 – 2007" },
  { id: "volvo-v70-3", brand: "volvo", label: "V70 (3rd)", years: "2007 – 2016" },
  { id: "volvo-xc60-1", brand: "volvo", label: "XC60 (1st)", years: "2008 – 2017" },
  { id: "volvo-xc90-1", brand: "volvo", label: "XC90 (1st)", years: "2002 – 2014" },
  { id: "volvo-xc90-2", brand: "volvo", label: "XC90 (2nd)", years: "2014 – present" },

  // Honda
  { id: "honda-1300", brand: "honda", label: "1300", years: "1969 – 1973" },
  { id: "honda-civic-sb", brand: "honda", label: "Civic I (SB/SM)", years: "1972 – 1979" },
  { id: "honda-civic-sl", brand: "honda", label: "Civic II (SL/SS)", years: "1979 – 1983" },
  { id: "honda-civic-ag", brand: "honda", label: "Civic III (AG/AH)", years: "1983 – 1987" },
  { id: "honda-civic-ed", brand: "honda", label: "Civic IV (EC/ED/EE)", years: "1987 – 1991" },
  { id: "honda-civic-eg", brand: "honda", label: "Civic V (EG/EH)", years: "1991 – 1995" },
  { id: "honda-civic-ek", brand: "honda", label: "Civic VI (EK)", years: "1995 – 2000" },
  { id: "honda-civic-em", brand: "honda", label: "Civic VII (EM/EP)", years: "2000 – 2005" },
  { id: "honda-civic-fd", brand: "honda", label: "Civic VIII (FD/FK)", years: "2005 – 2011" },
  { id: "honda-civic-fb", brand: "honda", label: "Civic IX (FB/FG)", years: "2011 – 2016" },
  { id: "honda-civic-fc", brand: "honda", label: "Civic X (FC/FK)", years: "2015 – 2021" },
  { id: "honda-civic-fl", brand: "honda", label: "Civic XI (FL)", years: "2021 – present" },
  { id: "honda-civic-typer-ep3", brand: "honda", label: "Civic Type R (EP3)", years: "2001 – 2005" },
  { id: "honda-civic-typer-fn2", brand: "honda", label: "Civic Type R (FN2)", years: "2006 – 2011" },
  { id: "honda-civic-typer-fk8", brand: "honda", label: "Civic Type R (FK8)", years: "2015 – 2021" },
  { id: "honda-civic-typer-fl5", brand: "honda", label: "Civic Type R (FL5)", years: "2022 – present" },
  { id: "honda-crx-af", brand: "honda", label: "CR-X (AF/AS)", years: "1983 – 1987" },
  { id: "honda-crx-ed", brand: "honda", label: "CR-X (ED/EE)", years: "1987 – 1991" },
  { id: "honda-cr-z", brand: "honda", label: "CR-Z (ZF1)", years: "2010 – 2016" },
  { id: "honda-accord-sj", brand: "honda", label: "Accord I (SJ/SM)", years: "1976 – 1981" },
  { id: "honda-accord-sy", brand: "honda", label: "Accord II (SY)", years: "1981 – 1985" },
  { id: "honda-accord-ca", brand: "honda", label: "Accord III (CA)", years: "1985 – 1989" },
  { id: "honda-accord-cb", brand: "honda", label: "Accord IV (CB)", years: "1990 – 1993" },
  { id: "honda-accord-cd", brand: "honda", label: "Accord V (CD)", years: "1993 – 1997" },
  { id: "honda-accord-cg", brand: "honda", label: "Accord VI (CG/CH)", years: "1998 – 2002" },
  { id: "honda-accord-cm", brand: "honda", label: "Accord VII (CM)", years: "2002 – 2007" },
  { id: "honda-accord-cu", brand: "honda", label: "Accord VIII (CU)", years: "2008 – 2012" },
  { id: "honda-accord-cr", brand: "honda", label: "Accord IX (CR)", years: "2013 – 2017" },
  { id: "honda-accord-cv", brand: "honda", label: "Accord X (CV)", years: "2018 – present" },
  { id: "honda-prelude-sn", brand: "honda", label: "Prelude I (SN)", years: "1978 – 1982" },
  { id: "honda-prelude-ab", brand: "honda", label: "Prelude II (AB)", years: "1982 – 1987" },
  { id: "honda-prelude-ba", brand: "honda", label: "Prelude III (BA)", years: "1987 – 1991" },
  { id: "honda-prelude-bb4", brand: "honda", label: "Prelude IV (BA8/BA9)", years: "1991 – 1996" },
  { id: "honda-prelude-bb5", brand: "honda", label: "Prelude V (BB)", years: "1996 – 2001" },
  { id: "honda-integra-av", brand: "honda", label: "Integra I (AV/DA)", years: "1985 – 1989" },
  { id: "honda-integra-db", brand: "honda", label: "Integra II (DA/DB)", years: "1989 – 1993" },
  { id: "honda-integra-dc", brand: "honda", label: "Integra III (DC2)", years: "1994 – 2001" },
  { id: "honda-legend-ka1", brand: "honda", label: "Legend I (KA)", years: "1985 – 1990" },
  { id: "honda-legend-ka7", brand: "honda", label: "Legend II (KA7/KA8)", years: "1990 – 1996" },
  { id: "honda-legend-ka9", brand: "honda", label: "Legend III (KA9)", years: "1996 – 2004" },
  { id: "honda-nsx-na1", brand: "honda", label: "NSX (NA1/NA2)", years: "1990 – 2005" },
  { id: "honda-nsx-nc1", brand: "honda", label: "NSX (NC1)", years: "2016 – present" },
  { id: "honda-s2000", brand: "honda", label: "S2000 (AP1/AP2)", years: "1999 – 2009" },
  { id: "honda-beat", brand: "honda", label: "Beat (PP1)", years: "1991 – 1996" },
  { id: "honda-s660", brand: "honda", label: "S660 (JW5)", years: "2015 – 2022" },
  { id: "honda-crv-rd1", brand: "honda", label: "CR-V I (RD)", years: "1995 – 2001" },
  { id: "honda-crv-rd4", brand: "honda", label: "CR-V II (RD4)", years: "2001 – 2006" },
  { id: "honda-crv-re3", brand: "honda", label: "CR-V III (RE)", years: "2007 – 2011" },
  { id: "honda-crv-rm4", brand: "honda", label: "CR-V IV (RM)", years: "2012 – 2016" },
  { id: "honda-crv-rw5", brand: "honda", label: "CR-V V (RW)", years: "2017 – 2022" },
  { id: "honda-crv-6", brand: "honda", label: "CR-V VI", years: "2023 – present" },
  { id: "honda-hrv-gh", brand: "honda", label: "HR-V I (GH)", years: "1999 – 2006" },
  { id: "honda-hrv-2", brand: "honda", label: "HR-V II (RS)", years: "2015 – present" },
  { id: "honda-zrv", brand: "honda", label: "ZR-V (RV)", years: "2022 – present" },
  { id: "honda-jazz-gd", brand: "honda", label: "Jazz / Fit I (GD)", years: "2001 – 2008" },
  { id: "honda-jazz-ge", brand: "honda", label: "Jazz / Fit II (GE)", years: "2007 – 2014" },
  { id: "honda-jazz-gk", brand: "honda", label: "Jazz / Fit III (GK)", years: "2013 – 2020" },
  { id: "honda-jazz-gr", brand: "honda", label: "Jazz / Fit IV (GR)", years: "2020 – present" },
  { id: "honda-odyssey-ra1", brand: "honda", label: "Odyssey I (RA)", years: "1994 – 1999" },
  { id: "honda-odyssey-rb1", brand: "honda", label: "Odyssey II (RB)", years: "1999 – 2004" },
  { id: "honda-odyssey-rb3", brand: "honda", label: "Odyssey III (RB3)", years: "2004 – 2013" },
  { id: "honda-insight-ze1", brand: "honda", label: "Insight I (ZE1)", years: "1999 – 2006" },
  { id: "honda-insight-ze2", brand: "honda", label: "Insight II (ZE2)", years: "2009 – 2014" },
  { id: "honda-insight-3", brand: "honda", label: "Insight III", years: "2018 – 2022" },
  { id: "honda-e", brand: "honda", label: "Honda e", years: "2020 – present" },
  { id: "honda-clarity", brand: "honda", label: "Clarity", years: "2017 – 2021" },
  { id: "honda-stream-rn1", brand: "honda", label: "Stream I (RN)", years: "2000 – 2014" },
  { id: "honda-fr-v", brand: "honda", label: "FR-V", years: "2004 – 2009" },
  { id: "honda-stepwgn", brand: "honda", label: "Stepwgn", years: "1996 – present" },
  { id: "honda-element", brand: "honda", label: "Element (YH)", years: "2002 – 2011" },
  { id: "honda-city-1", brand: "honda", label: "City I", years: "1981 – 1986" },
  { id: "honda-city-gx", brand: "honda", label: "City (GM/GX)", years: "1996 – present" },
  { id: "honda-vigor-ka5", brand: "honda", label: "Vigor (KA5)", years: "1981 – 1995" },
  { id: "honda-torneo", brand: "honda", label: "Torneo (CF)", years: "1997 – 2005" },
  { id: "honda-inspire-1", brand: "honda", label: "Inspire I", years: "1989 – 1995" },
  { id: "honda-inspire-2", brand: "honda", label: "Inspire II (UA)", years: "1995 – 2007" },

  // Toyota
  { id: "toyota-corolla-e12", brand: "toyota", label: "Corolla (E120)", years: "2000 – 2007" },
  { id: "toyota-corolla-e15", brand: "toyota", label: "Corolla (E150)", years: "2006 – 2013" },
  { id: "toyota-corolla-e21", brand: "toyota", label: "Corolla (E210)", years: "2018 – present" },
  { id: "toyota-avensis-t25", brand: "toyota", label: "Avensis (T25)", years: "2003 – 2008" },
  { id: "toyota-avensis-t27", brand: "toyota", label: "Avensis (T27)", years: "2009 – 2018" },
  { id: "toyota-yaris-xp10", brand: "toyota", label: "Yaris (XP10)", years: "1999 – 2005" },
  { id: "toyota-yaris-xp90", brand: "toyota", label: "Yaris (XP90)", years: "2005 – 2011" },
  { id: "toyota-yaris-xp13", brand: "toyota", label: "Yaris (XP130)", years: "2011 – 2020" },
  { id: "toyota-rav4-xa30", brand: "toyota", label: "RAV4 (XA30)", years: "2005 – 2012" },
  { id: "toyota-rav4-xa40", brand: "toyota", label: "RAV4 (XA40)", years: "2012 – 2018" },
  { id: "toyota-land-cruiser-j120", brand: "toyota", label: "Land Cruiser (J120)", years: "2002 – 2009" },
  { id: "toyota-land-cruiser-j150", brand: "toyota", label: "Land Cruiser (J150)", years: "2009 – present" },
  { id: "toyota-hilux-an10", brand: "toyota", label: "Hilux (AN10)", years: "2004 – 2015" },
  { id: "toyota-supra-a80", brand: "toyota", label: "Supra (A80)", years: "1993 – 2002" },
  { id: "toyota-celica-t23", brand: "toyota", label: "Celica (T230)", years: "1999 – 2006" },
  { id: "toyota-mr2-w30", brand: "toyota", label: "MR2 (W30)", years: "1999 – 2007" },
  { id: "toyota-prius-xw20", brand: "toyota", label: "Prius (XW20)", years: "2003 – 2009" },
  { id: "toyota-prius-xw30", brand: "toyota", label: "Prius (XW30)", years: "2009 – 2015" },
  { id: "toyota-aygo-ab10", brand: "toyota", label: "Aygo (AB10)", years: "2005 – 2014" },
  { id: "toyota-auris-e150", brand: "toyota", label: "Auris (E150)", years: "2006 – 2012" },
  { id: "toyota-corolla-verso-ar10", brand: "toyota", label: "Corolla Verso (AR10)", years: "2004 – 2009" },

  // Alfa Romeo
  { id: "alfa-spider-105", brand: "alfa-romeo", label: "Spider (105/115)", years: "1966 – 1993" },
  { id: "alfa-gtv-916", brand: "alfa-romeo", label: "GTV / Spider (916)", years: "1995 – 2006" },
  { id: "alfa-145", brand: "alfa-romeo", label: "145 / 146", years: "1994 – 2001" },
  { id: "alfa-147", brand: "alfa-romeo", label: "147", years: "2000 – 2010" },
  { id: "alfa-155", brand: "alfa-romeo", label: "155", years: "1992 – 1998" },
  { id: "alfa-156", brand: "alfa-romeo", label: "156", years: "1997 – 2007" },
  { id: "alfa-159", brand: "alfa-romeo", label: "159", years: "2005 – 2011" },
  { id: "alfa-166", brand: "alfa-romeo", label: "166", years: "1998 – 2007" },
  { id: "alfa-brera", brand: "alfa-romeo", label: "Brera", years: "2005 – 2010" },
  { id: "alfa-mito", brand: "alfa-romeo", label: "MiTo", years: "2008 – 2018" },
  { id: "alfa-giulietta-940", brand: "alfa-romeo", label: "Giulietta (940)", years: "2010 – 2020" },
  { id: "alfa-giulia-952", brand: "alfa-romeo", label: "Giulia (952)", years: "2016 – present" },
  { id: "alfa-stelvio", brand: "alfa-romeo", label: "Stelvio", years: "2016 – present" },

  // Citroën
  { id: "citroen-2cv", brand: "citroen", label: "2CV", years: "1948 – 1990" },
  { id: "citroen-ds-classic", brand: "citroen", label: "DS (classic)", years: "1955 – 1975" },
  { id: "citroen-cx", brand: "citroen", label: "CX", years: "1974 – 1991" },
  { id: "citroen-bx", brand: "citroen", label: "BX", years: "1982 – 1994" },
  { id: "citroen-xantia", brand: "citroen", label: "Xantia", years: "1993 – 2001" },
  { id: "citroen-xsara", brand: "citroen", label: "Xsara", years: "1997 – 2006" },
  { id: "citroen-xsara-picasso", brand: "citroen", label: "Xsara Picasso", years: "1999 – 2012" },
  { id: "citroen-c1", brand: "citroen", label: "C1", years: "2005 – 2022" },
  { id: "citroen-c2", brand: "citroen", label: "C2", years: "2003 – 2009" },
  { id: "citroen-c3-1", brand: "citroen", label: "C3 (1st)", years: "2002 – 2009" },
  { id: "citroen-c3-2", brand: "citroen", label: "C3 (2nd)", years: "2009 – 2016" },
  { id: "citroen-c4-1", brand: "citroen", label: "C4 (1st)", years: "2004 – 2010" },
  { id: "citroen-c4-2", brand: "citroen", label: "C4 (2nd)", years: "2010 – 2018" },
  { id: "citroen-c5-1", brand: "citroen", label: "C5 (1st)", years: "2000 – 2008" },
  { id: "citroen-c5-2", brand: "citroen", label: "C5 (2nd)", years: "2008 – 2017" },
  { id: "citroen-berlingo-1", brand: "citroen", label: "Berlingo (1st)", years: "1996 – 2010" },
  { id: "citroen-berlingo-2", brand: "citroen", label: "Berlingo (2nd)", years: "2008 – 2018" },
  { id: "citroen-jumper", brand: "citroen", label: "Jumper / Relay", years: "1994 – present" },

  // Fiat
  { id: "fiat-500-classic", brand: "fiat", label: "500 (classic)", years: "1957 – 1975" },
  { id: "fiat-126", brand: "fiat", label: "126", years: "1972 – 2000" },
  { id: "fiat-uno", brand: "fiat", label: "Uno", years: "1983 – 1995" },
  { id: "fiat-panda-1", brand: "fiat", label: "Panda (1st)", years: "1980 – 2003" },
  { id: "fiat-panda-169", brand: "fiat", label: "Panda (169)", years: "2003 – 2012" },
  { id: "fiat-panda-319", brand: "fiat", label: "Panda (319)", years: "2011 – present" },
  { id: "fiat-punto-176", brand: "fiat", label: "Punto (176)", years: "1993 – 1999" },
  { id: "fiat-punto-188", brand: "fiat", label: "Punto (188)", years: "1999 – 2010" },
  { id: "fiat-grande-punto", brand: "fiat", label: "Grande Punto / Evo (199)", years: "2005 – 2018" },
  { id: "fiat-bravo-198", brand: "fiat", label: "Bravo (198)", years: "2007 – 2014" },
  { id: "fiat-stilo", brand: "fiat", label: "Stilo", years: "2001 – 2010" },
  { id: "fiat-500-312", brand: "fiat", label: "500 (312)", years: "2007 – present" },
  { id: "fiat-doblo-1", brand: "fiat", label: "Doblò (1st)", years: "2000 – 2010" },
  { id: "fiat-doblo-2", brand: "fiat", label: "Doblò (2nd)", years: "2010 – 2022" },
  { id: "fiat-ducato-230", brand: "fiat", label: "Ducato (230)", years: "1994 – 2006" },
  { id: "fiat-ducato-250", brand: "fiat", label: "Ducato (250)", years: "2006 – present" },
  { id: "fiat-barchetta", brand: "fiat", label: "Barchetta", years: "1995 – 2005" },
  { id: "fiat-coupe", brand: "fiat", label: "Coupé", years: "1993 – 2000" },

  // Kia
  { id: "kia-ceed-ed", brand: "kia", label: "Cee'd (ED)", years: "2006 – 2012" },
  { id: "kia-ceed-jd", brand: "kia", label: "Cee'd (JD)", years: "2012 – 2018" },
  { id: "kia-ceed-cd", brand: "kia", label: "Ceed (CD)", years: "2018 – present" },
  { id: "kia-rio-jb", brand: "kia", label: "Rio (JB)", years: "2005 – 2011" },
  { id: "kia-rio-ub", brand: "kia", label: "Rio (UB)", years: "2011 – 2017" },
  { id: "kia-picanto-sa", brand: "kia", label: "Picanto (SA)", years: "2004 – 2011" },
  { id: "kia-picanto-ta", brand: "kia", label: "Picanto (TA)", years: "2011 – 2017" },
  { id: "kia-sportage-ke", brand: "kia", label: "Sportage (KM)", years: "2004 – 2010" },
  { id: "kia-sportage-sl", brand: "kia", label: "Sportage (SL)", years: "2010 – 2015" },
  { id: "kia-sportage-ql", brand: "kia", label: "Sportage (QL)", years: "2015 – 2021" },
  { id: "kia-sorento-bl", brand: "kia", label: "Sorento (BL)", years: "2002 – 2009" },
  { id: "kia-sorento-xm", brand: "kia", label: "Sorento (XM)", years: "2009 – 2014" },
  { id: "kia-optima-tf", brand: "kia", label: "Optima (TF)", years: "2010 – 2015" },
  { id: "kia-venga", brand: "kia", label: "Venga", years: "2009 – 2019" },

  // Lancia
  { id: "lancia-delta-integrale", brand: "lancia", label: "Delta HF / Integrale", years: "1979 – 1994" },
  { id: "lancia-delta-844", brand: "lancia", label: "Delta (844)", years: "2008 – 2014" },
  { id: "lancia-ypsilon-843", brand: "lancia", label: "Ypsilon (843)", years: "2003 – 2011" },
  { id: "lancia-ypsilon-846", brand: "lancia", label: "Ypsilon (846)", years: "2011 – present" },
  { id: "lancia-thesis", brand: "lancia", label: "Thesis", years: "2001 – 2009" },
  { id: "lancia-lybra", brand: "lancia", label: "Lybra", years: "1998 – 2005" },
  { id: "lancia-kappa", brand: "lancia", label: "Kappa", years: "1994 – 2001" },
  { id: "lancia-fulvia", brand: "lancia", label: "Fulvia", years: "1963 – 1976" },
  { id: "lancia-beta", brand: "lancia", label: "Beta", years: "1972 – 1984" },

  // Land Rover
  { id: "lr-defender-classic", brand: "land-rover", label: "Defender (classic)", years: "1983 – 2016" },
  { id: "lr-defender-l663", brand: "land-rover", label: "Defender (L663)", years: "2020 – present" },
  { id: "lr-discovery-1", brand: "land-rover", label: "Discovery 1", years: "1989 – 1998" },
  { id: "lr-discovery-2", brand: "land-rover", label: "Discovery 2", years: "1998 – 2004" },
  { id: "lr-discovery-3", brand: "land-rover", label: "Discovery 3 (L319)", years: "2004 – 2009" },
  { id: "lr-discovery-4", brand: "land-rover", label: "Discovery 4", years: "2009 – 2016" },
  { id: "lr-freelander-1", brand: "land-rover", label: "Freelander 1", years: "1997 – 2006" },
  { id: "lr-freelander-2", brand: "land-rover", label: "Freelander 2 (L359)", years: "2006 – 2014" },
  { id: "lr-range-rover-classic", brand: "land-rover", label: "Range Rover Classic", years: "1970 – 1996" },
  { id: "lr-range-rover-p38", brand: "land-rover", label: "Range Rover (P38A)", years: "1994 – 2002" },
  { id: "lr-range-rover-l322", brand: "land-rover", label: "Range Rover (L322)", years: "2002 – 2012" },
  { id: "lr-range-rover-l405", brand: "land-rover", label: "Range Rover (L405)", years: "2012 – 2021" },
  { id: "lr-range-rover-sport-l320", brand: "land-rover", label: "Range Rover Sport (L320)", years: "2005 – 2013" },
  { id: "lr-range-rover-sport-l494", brand: "land-rover", label: "Range Rover Sport (L494)", years: "2013 – 2022" },
  { id: "lr-evoque-l538", brand: "land-rover", label: "Range Rover Evoque (L538)", years: "2011 – 2018" },

  // Mazda
  { id: "mazda-mx5-na", brand: "mazda", label: "MX-5 (NA)", years: "1989 – 1997" },
  { id: "mazda-mx5-nb", brand: "mazda", label: "MX-5 (NB)", years: "1998 – 2005" },
  { id: "mazda-mx5-nc", brand: "mazda", label: "MX-5 (NC)", years: "2005 – 2015" },
  { id: "mazda-mx5-nd", brand: "mazda", label: "MX-5 (ND)", years: "2015 – present" },
  { id: "mazda-rx7-fd", brand: "mazda", label: "RX-7 (FD)", years: "1992 – 2002" },
  { id: "mazda-rx8", brand: "mazda", label: "RX-8", years: "2003 – 2012" },
  { id: "mazda-2-de", brand: "mazda", label: "2 (DE)", years: "2007 – 2014" },
  { id: "mazda-3-bk", brand: "mazda", label: "3 (BK)", years: "2003 – 2009" },
  { id: "mazda-3-bl", brand: "mazda", label: "3 (BL)", years: "2009 – 2013" },
  { id: "mazda-3-bm", brand: "mazda", label: "3 (BM)", years: "2013 – 2018" },
  { id: "mazda-6-gg", brand: "mazda", label: "6 (GG)", years: "2002 – 2008" },
  { id: "mazda-6-gh", brand: "mazda", label: "6 (GH)", years: "2007 – 2012" },
  { id: "mazda-6-gj", brand: "mazda", label: "6 (GJ)", years: "2012 – present" },
  { id: "mazda-cx5-ke", brand: "mazda", label: "CX-5 (KE)", years: "2012 – 2017" },
  { id: "mazda-323-bg", brand: "mazda", label: "323 (BG)", years: "1989 – 1994" },

  // Mitsubishi
  { id: "mitsubishi-lancer-evo", brand: "mitsubishi", label: "Lancer Evolution IV–IX", years: "1996 – 2007" },
  { id: "mitsubishi-lancer-evo-x", brand: "mitsubishi", label: "Lancer Evolution X", years: "2007 – 2016" },
  { id: "mitsubishi-lancer-cy", brand: "mitsubishi", label: "Lancer (CY)", years: "2007 – 2017" },
  { id: "mitsubishi-colt-z30", brand: "mitsubishi", label: "Colt (Z30)", years: "2002 – 2012" },
  { id: "mitsubishi-outlander-2", brand: "mitsubishi", label: "Outlander (2nd, CW)", years: "2006 – 2012" },
  { id: "mitsubishi-outlander-3", brand: "mitsubishi", label: "Outlander (3rd, GF)", years: "2012 – 2021" },
  { id: "mitsubishi-asx", brand: "mitsubishi", label: "ASX", years: "2010 – present" },
  { id: "mitsubishi-pajero-3", brand: "mitsubishi", label: "Pajero (3rd)", years: "1999 – 2006" },
  { id: "mitsubishi-pajero-4", brand: "mitsubishi", label: "Pajero (4th)", years: "2006 – 2021" },
  { id: "mitsubishi-l200-4", brand: "mitsubishi", label: "L200 (4th)", years: "2006 – 2015" },
  { id: "mitsubishi-3000gt", brand: "mitsubishi", label: "3000GT / GTO", years: "1990 – 1999" },
  { id: "mitsubishi-eclipse-2g", brand: "mitsubishi", label: "Eclipse (2G)", years: "1995 – 1999" },

  // Nissan
  { id: "nissan-240z", brand: "nissan", label: "240Z / 260Z (S30)", years: "1969 – 1978" },
  { id: "nissan-300zx-z32", brand: "nissan", label: "300ZX (Z32)", years: "1989 – 2000" },
  { id: "nissan-350z", brand: "nissan", label: "350Z (Z33)", years: "2002 – 2009" },
  { id: "nissan-370z", brand: "nissan", label: "370Z (Z34)", years: "2009 – 2020" },
  { id: "nissan-skyline-r32", brand: "nissan", label: "Skyline GT-R (R32)", years: "1989 – 1994" },
  { id: "nissan-skyline-r33", brand: "nissan", label: "Skyline GT-R (R33)", years: "1993 – 1998" },
  { id: "nissan-skyline-r34", brand: "nissan", label: "Skyline GT-R (R34)", years: "1999 – 2002" },
  { id: "nissan-gtr-r35", brand: "nissan", label: "GT-R (R35)", years: "2007 – present" },
  { id: "nissan-silvia-s13", brand: "nissan", label: "Silvia / 200SX (S13)", years: "1988 – 1994" },
  { id: "nissan-silvia-s14", brand: "nissan", label: "Silvia / 200SX (S14)", years: "1993 – 1999" },
  { id: "nissan-micra-k11", brand: "nissan", label: "Micra (K11)", years: "1992 – 2002" },
  { id: "nissan-micra-k12", brand: "nissan", label: "Micra (K12)", years: "2002 – 2010" },
  { id: "nissan-qashqai-j10", brand: "nissan", label: "Qashqai (J10)", years: "2006 – 2013" },
  { id: "nissan-qashqai-j11", brand: "nissan", label: "Qashqai (J11)", years: "2013 – 2021" },
  { id: "nissan-juke-f15", brand: "nissan", label: "Juke (F15)", years: "2010 – 2019" },
  { id: "nissan-x-trail-t31", brand: "nissan", label: "X-Trail (T31)", years: "2007 – 2014" },
  { id: "nissan-navara-d40", brand: "nissan", label: "Navara (D40)", years: "2004 – 2015" },
  { id: "nissan-patrol-y61", brand: "nissan", label: "Patrol (Y61)", years: "1997 – 2016" },

  // Peugeot
  { id: "peugeot-205", brand: "peugeot", label: "205", years: "1983 – 1998" },
  { id: "peugeot-306", brand: "peugeot", label: "306", years: "1993 – 2002" },
  { id: "peugeot-307", brand: "peugeot", label: "307", years: "2001 – 2008" },
  { id: "peugeot-308-t7", brand: "peugeot", label: "308 (T7)", years: "2007 – 2014" },
  { id: "peugeot-308-t9", brand: "peugeot", label: "308 (T9)", years: "2013 – 2021" },
  { id: "peugeot-206", brand: "peugeot", label: "206", years: "1998 – 2012" },
  { id: "peugeot-207", brand: "peugeot", label: "207", years: "2006 – 2014" },
  { id: "peugeot-208-1", brand: "peugeot", label: "208 (1st)", years: "2012 – 2019" },
  { id: "peugeot-406", brand: "peugeot", label: "406", years: "1995 – 2004" },
  { id: "peugeot-407", brand: "peugeot", label: "407", years: "2004 – 2011" },
  { id: "peugeot-508-1", brand: "peugeot", label: "508 (1st)", years: "2010 – 2018" },
  { id: "peugeot-3008-1", brand: "peugeot", label: "3008 (1st)", years: "2009 – 2016" },
  { id: "peugeot-partner-1", brand: "peugeot", label: "Partner (1st)", years: "1996 – 2008" },
  { id: "peugeot-boxer", brand: "peugeot", label: "Boxer", years: "1994 – present" },
  { id: "peugeot-504", brand: "peugeot", label: "504", years: "1968 – 1983" },

  // Subaru
  { id: "subaru-impreza-gc", brand: "subaru", label: "Impreza (GC/GF)", years: "1992 – 2000" },
  { id: "subaru-impreza-gd", brand: "subaru", label: "Impreza (GD/GG)", years: "2000 – 2007" },
  { id: "subaru-impreza-gr", brand: "subaru", label: "Impreza / WRX STI (GR/GV)", years: "2007 – 2014" },
  { id: "subaru-wrx-va", brand: "subaru", label: "WRX / STI (VA)", years: "2014 – 2021" },
  { id: "subaru-legacy-be", brand: "subaru", label: "Legacy (BE/BH)", years: "1998 – 2003" },
  { id: "subaru-legacy-bl", brand: "subaru", label: "Legacy / Outback (BL/BP)", years: "2003 – 2009" },
  { id: "subaru-forester-sg", brand: "subaru", label: "Forester (SG)", years: "2002 – 2008" },
  { id: "subaru-forester-sh", brand: "subaru", label: "Forester (SH)", years: "2008 – 2013" },
  { id: "subaru-brz-zc6", brand: "subaru", label: "BRZ (ZC6)", years: "2012 – 2020" },
  { id: "subaru-svx", brand: "subaru", label: "SVX", years: "1991 – 1997" },

  // Yamaha (motorcycles)
  { id: "yamaha-r1", brand: "yamaha", label: "YZF-R1", years: "1998 – present" },
  { id: "yamaha-r6", brand: "yamaha", label: "YZF-R6", years: "1999 – 2020" },
  { id: "yamaha-mt07", brand: "yamaha", label: "MT-07", years: "2014 – present" },
  { id: "yamaha-mt09", brand: "yamaha", label: "MT-09", years: "2013 – present" },
  { id: "yamaha-xj6", brand: "yamaha", label: "XJ6", years: "2009 – 2016" },
  { id: "yamaha-fz6", brand: "yamaha", label: "FZ6", years: "2004 – 2010" },
  { id: "yamaha-tmax", brand: "yamaha", label: "TMAX", years: "2001 – present" },
  { id: "yamaha-xmax", brand: "yamaha", label: "XMAX", years: "2005 – present" },
  { id: "yamaha-tenere-700", brand: "yamaha", label: "Ténéré 700", years: "2019 – present" },
  { id: "yamaha-xt660", brand: "yamaha", label: "XT660", years: "2004 – 2016" },
  { id: "yamaha-vmax", brand: "yamaha", label: "V-Max", years: "1985 – 2020" },
  { id: "yamaha-rd350", brand: "yamaha", label: "RD350", years: "1973 – 1975" },
  // Honda (motorcycles)
  { id: "honda-moto-xl600vl-transalp", brand: "honda-moto", label: "XL600VL Transalp", years: "" },
  { id: "honda-moto-xr650r1", brand: "honda-moto", label: "XR650R1", years: "" },
  { id: "honda-moto-xr650ry", brand: "honda-moto", label: "XR650RY", years: "" },
  { id: "honda-moto-nx500n-p-r-dominator", brand: "honda-moto", label: "NX500N-P-R Dominator", years: "" },
  { id: "honda-moto-nx650r-dominator", brand: "honda-moto", label: "NX650R Dominator", years: "" },
  { id: "honda-moto-nx650l-dominator", brand: "honda-moto", label: "NX650L Dominator", years: "" },
  { id: "honda-moto-xr250rg", brand: "honda-moto", label: "XR250RG", years: "" },
  { id: "honda-moto-xl600vm-transalp", brand: "honda-moto", label: "XL600VM Transalp", years: "" },
  { id: "honda-moto-xl600vn-transalp", brand: "honda-moto", label: "XL600VN Transalp", years: "" },
  { id: "honda-moto-xl600vp-transalp", brand: "honda-moto", label: "XL600VP Transalp", years: "" },
  { id: "honda-moto-xl600vr-transalp", brand: "honda-moto", label: "XL600VR Transalp", years: "" },
  { id: "honda-moto-xl600vt-transalp", brand: "honda-moto", label: "XL600VT Transalp", years: "" },
  { id: "honda-moto-xl600vh-transalp", brand: "honda-moto", label: "XL600VH Transalp", years: "" },
  { id: "honda-moto-xl600vj-transalp", brand: "honda-moto", label: "XL600VJ Transalp", years: "" },
  { id: "honda-moto-xl600vk-transalp", brand: "honda-moto", label: "XL600VK Transalp", years: "" },
  { id: "honda-moto-nx650j-dominator", brand: "honda-moto", label: "NX650J Dominator", years: "" },
  { id: "honda-moto-nx650s-dominator", brand: "honda-moto", label: "NX650S Dominator", years: "" },
  { id: "honda-moto-nx650k-dominator", brand: "honda-moto", label: "NX650K Dominator", years: "" },
  { id: "honda-moto-nx650m-dominator", brand: "honda-moto", label: "NX650M Dominator", years: "" },
  { id: "honda-moto-nx650n-dominator", brand: "honda-moto", label: "NX650N Dominator", years: "" },
  { id: "honda-moto-nx650p-dominator", brand: "honda-moto", label: "NX650P Dominator", years: "" },
  { id: "honda-moto-nx650t-dominator", brand: "honda-moto", label: "NX650T Dominator", years: "" },
  { id: "honda-moto-xr250re", brand: "honda-moto", label: "XR250RE", years: "" },
  { id: "honda-moto-xr250rf", brand: "honda-moto", label: "XR250RF", years: "" },
  { id: "honda-moto-xr250rh", brand: "honda-moto", label: "XR250RH", years: "" },
  { id: "honda-moto-xr250rk", brand: "honda-moto", label: "XR250RK", years: "" },
  { id: "honda-moto-xr250rl", brand: "honda-moto", label: "XR250RL", years: "" },
  { id: "honda-moto-xr250rm", brand: "honda-moto", label: "XR250RM", years: "" },
  { id: "honda-moto-xr250rn", brand: "honda-moto", label: "XR250RN", years: "" },
  { id: "honda-moto-xr250rp", brand: "honda-moto", label: "XR250RP", years: "" },
  { id: "honda-moto-xr250rr", brand: "honda-moto", label: "XR250RR", years: "" },
  { id: "honda-moto-xr250rs", brand: "honda-moto", label: "XR250RS", years: "" },
  { id: "honda-moto-xl600rmg", brand: "honda-moto", label: "XL600RMG", years: "" },
  { id: "honda-moto-xl600rd", brand: "honda-moto", label: "XL600RD", years: "" },
  { id: "honda-moto-xr600rt", brand: "honda-moto", label: "XR600RT", years: "" },
  { id: "honda-moto-xl350r", brand: "honda-moto", label: "XL350R", years: "" },
  { id: "honda-moto-xlr125rw", brand: "honda-moto", label: "XLR125RW", years: "" },
  { id: "honda-moto-nx500s-dominator", brand: "honda-moto", label: "NX500S Dominator", years: "" },
  { id: "honda-moto-nx500t-dominator", brand: "honda-moto", label: "NX500T Dominator", years: "" },
  { id: "honda-moto-xr650r2", brand: "honda-moto", label: "XR650R2", years: "" },
  { id: "honda-moto-xr650r3", brand: "honda-moto", label: "XR650R3", years: "" },
  { id: "honda-moto-xr650r4", brand: "honda-moto", label: "XR650R4", years: "" },
  { id: "honda-moto-xr650r5", brand: "honda-moto", label: "XR650R5", years: "" },
  { id: "honda-moto-xr650r6", brand: "honda-moto", label: "XR650R6", years: "" },
  { id: "honda-moto-xr650r7", brand: "honda-moto", label: "XR650R7", years: "" },
  { id: "honda-moto-crm125rv", brand: "honda-moto", label: "CRM125RV", years: "" },
  { id: "honda-moto-crm125rx", brand: "honda-moto", label: "CRM125RX", years: "" },
  { id: "honda-moto-crm50rt", brand: "honda-moto", label: "CRM50RT", years: "" },
  { id: "honda-moto-xr600rs", brand: "honda-moto", label: "XR600RS", years: "" },
];


export const CATEGORIES: CategoryInfo[] = [
  { id: "brakes", label: "Brakes" },
  { id: "suspension", label: "Suspension & Steering" },
  { id: "engine", label: "Engine" },
  { id: "cooling", label: "Cooling" },
  { id: "electrical", label: "Electrical" },
  { id: "body", label: "Body & Trim" },
  { id: "interior", label: "Interior" },
  { id: "lighting", label: "Lighting" },
  { id: "exhaust", label: "Exhaust" },
  { id: "transmission", label: "Transmission" },
];

/**
 * Years for admin-entered ("custom") models encoded as `${brandId}::${label}`.
 * Keys are matched case-insensitively.
 */
export const CUSTOM_MODEL_YEARS: Record<string, string> = {
  "audi::a3 8p": "2003 – 2013",
  "kia::ceed": "2006 – 2018",
  "kia::sportage": "1993 – present",
  "mazda::miata": "1989 – present",
  "mazda::mx-5": "1989 – present",
  "toyota::avensis": "1997 – 2018",
  "toyota::corolla": "1966 – present",
  "toyota::corolla verso": "2001 – 2009",
};


/** Resolve display years for a preset or custom model id. */
export function modelYears(id: string): string | undefined {
  const preset = MODELS.find((m) => m.id === id);
  if (preset) return preset.years;
  return CUSTOM_MODEL_YEARS[id.toLowerCase()] ?? splitCustomYears(id.split("::").slice(1).join("::")).years;
}

const TRAILING_YEARS = /\s*\(?\s*((?:19|20)\d{2})\s*[–—-]\s*((?:19|20)\d{2}|present)\s*\)?\s*$/i;
/** Split a custom model label like "Pajero (2nd, V20) 1991 – 1999" into label + years. */
export function splitCustomYears(label: string): { label: string; years?: string } {
  const m = label.match(TRAILING_YEARS);
  if (!m) return { label };
  const rest = label.slice(0, m.index).trim();
  return { label: rest || label, years: `${m[1]} – ${m[2].toLowerCase()}` };
}

/**
 * Natural sort for model labels: letter prefix first, then the number that
 * follows it (W108 → W109 → … → W124), then the next letter group.
 */
export function compareModelLabels(a: string, b: string): number {
  const tokenize = (s: string) =>
    s
      .toLowerCase()
      .match(/\d+|[a-zà-ÿ]+/g) ?? [];
  const ta = tokenize(a);
  const tb = tokenize(b);
  for (let i = 0; i < Math.max(ta.length, tb.length); i++) {
    const x = ta[i];
    const y = tb[i];
    if (x === undefined) return -1;
    if (y === undefined) return 1;
    const nx = /^\d+$/.test(x);
    const ny = /^\d+$/.test(y);
    if (nx && ny) {
      if (Number(x) !== Number(y)) return Number(x) - Number(y);
    } else if (nx !== ny) {
      // Letters sort before pure numbers at the same position
      return nx ? 1 : -1;
    } else if (x !== y) {
      return x < y ? -1 : 1;
    }
  }
  return 0;
}

export const MODEL_MAP: Record<ModelId, ModelInfo> = Object.fromEntries(
  MODELS.map((m) => [m.id, m]),
) as Record<ModelId, ModelInfo>;

export const CATEGORY_MAP: Record<CategoryId, CategoryInfo> = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c]),
) as Record<CategoryId, CategoryInfo>;

export const PRODUCTS: Product[] = [];

export function productImage(p: Product): { kind: "image"; url: string } | { kind: "silhouette" } {
  // Will be resolved at component level using assets; here we just hint.
  return { kind: "silhouette" };
}